import { Star } from "lucide-react";

import ColorBadge from "@/components/shared/ColorBadge";
import { teamColor } from "@/lib/teamColors";
import type { Team } from "@/hooks/useTeams";

interface TeamChipProps {
  team: Pick<Team, "id" | "name" | "color">;
  /**
   * "primary" — the one team that owns this ticket (the column that used to be
   * called the queue). "helper" — one of the others it also concerns.
   *
   * The same distinction people get, in chip form: the primary leads the list,
   * carries a star, and keeps the light tint; helpers are the same chip with
   * the fill taken out. Both use the team's own colour, because they refer to
   * the same team.
   *
   * The primary used to be SOLID, which put a second block of colour on a row
   * that already has a filled status pill — two loud labels, one of them
   * answering a question nobody was asking at that volume. The star carries
   * the meaning now and the tint carries the emphasis.
   */
  variant?: "primary" | "helper";
}

const TeamChip = ({ team, variant = "helper" }: TeamChipProps) => (
  <ColorBadge
    label={team.name}
    color={teamColor(team)}
    tinted={variant === "primary"}
    outline={variant === "helper"}
    shape="chip"
    leading={variant === "primary" ? <Star className="mr-1 h-2.5 w-2.5 shrink-0 fill-current" aria-hidden /> : null}
  />
);

export default TeamChip;
